export enum Languages {
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Pt = 'pt',
  PtBr = 'pt-BR'
}

/* CAUTION: This enum is used exclusively for languages that are supported by Hotmart, do not include unsupported languages */
export enum SupportedLanguages {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  PtBr = 'pt-BR'
}
